import React from 'react';

const Layout = (props: { children: React.ReactNode }) => {
	return <main className="flex-grow bg-gray-gray200">{props.children}</main>;
};

export default Layout;
